import React from 'react';
import PropTypes from 'prop-types';

import './Input.scss';

export const Input = (props) => {
  Input.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    onInput: PropTypes.func,
    additionalClass: PropTypes.string
  };

  const { name, type, placeholder, additionalClass, onInput } = props;

  return (
    <div className="input">
      <div className="input__container">
        <span className="input__placeholder">{placeholder}</span>
        <input onInput={onInput} className={`input-${type} ${additionalClass && additionalClass}`} type={type} name={name}/>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/elements/Input/Input.js